import { Pipe, PipeTransform } from "@angular/core";
import { ProductTagViewModel, TagTypeViewModel } from "src/domain/client";
import { TagType } from "src/enums/tagEnums";

@Pipe({
  name: "tag",
})
export class TagPipe implements PipeTransform {
  transform(
    tags: ProductTagViewModel[] | undefined | null,
    type: TagType,
  ): (ProductTagViewModel & { tag: { tagType: TagTypeViewModel } }) | null {
    return (
      tags?.find(
        (
          _,
        ): _ is ProductTagViewModel & { tag: { tagType: TagTypeViewModel } } =>
          _.tag?.tagType?.name === type,
      ) ?? null
    );
  }
}
